
import React from "react";
import { Button } from "@/components/ui/button";

type Props = {
  fetchError: string;
  onPrev: () => void;
  onRetry: () => void;
};

const Step2NumberError: React.FC<Props> = ({ fetchError, onPrev, onRetry }) => (
  <div className="flex flex-col items-center justify-center py-8">
    <div className="text-red-500 mb-4">⚠️</div>
    <p className="text-center mb-4">{fetchError}</p>
    <Button onClick={onPrev} variant="secondary">Back</Button>
    <Button 
      onClick={onRetry}
      className="mt-4"
      variant="outline"
    >
      Retry
    </Button>
  </div>
);

export default Step2NumberError;
